/* import __COLOCATED_TEMPLATE__ from './multi-payment-pill.hbs'; */
import Component from '@ember/component';
import Money from '@square/dashboard-money/models/money';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  amount: null,
  merchantName: null,
  merchantImageUrl: null,
  init(...args) {
    this._super(...args);
    this.formattedAmount = this.amount.currencyCode ? Money.fromProto(this.amount).unsigned.get('formatted') : null;
  }
});